module.exports = __webpack_public_path__ + "static/media/animal-countryside-agriculture-farm.d6cfa832.jpg";